<bw-header-label-cell-legacy @fadeIn [labelCellConfig]="creditPendingCellConfig" [hasContent]="true">
  <bw-bui-tile-legacy tileMargin="0 0 8px 0">
    <bui-tile-card-legacy (click)="navigateToCreditSetup()" [cardBackground]="'var(--white)'" [cardBorder]="'1px solid var(--gray-10)'">
      <bw-bui-row-legacy [rightIconName]="'chevron_right'" rightIconColor="var(--secondary-text)">
        <div class="row-content">
          <bw-bui-column-legacy
            [rowSpacing]="4"
            [rows]="[
              { type: 'detail', content: 'CREDIT_PENDING_TITLE' | translate, color: 'var(--primary-text)' },
              { type: 'label', content: 'CREDIT_PENDING_DESC' | translate, color: 'var(--secondary-text)' }
            ]"
          ></bw-bui-column-legacy>
        </div>
      </bw-bui-row-legacy>
    </bui-tile-card-legacy>
  </bw-bui-tile-legacy>
</bw-header-label-cell-legacy>
